import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

const BtnSave = (props) => {
    const { t } = useTranslation();

    return (
        <div style={{ borderLeft: '1px solid #DBDBDB' }} className="ml-6">
            <Button
                onClick={props.saveDraft}
                className="text-[#1890FF]"
                type="link"
            >
                {t('Save Draft')}
            </Button>
            <span>{t('to save the latest changes')}</span>
        </div>
    );
};

export default BtnSave;
